import React, {Component} from 'react'
import {connect} from 'react-redux'
import ParameterRow from "./ParameterRow"
import {gunaldiStyles} from "../SharedComponents/GunaldiDesignStyles";

class FilesResponseParams extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div style={{ marginBottom: "12px" }}>
                    <ParameterRow
                        parameter="page"
                        type={"integer"}
                        body={<div>
                            <div style={{ marginBottom: "2px"}}>
                                Current page number (1-indexed).
                            </div>
                        </div>}
                    />
                </div>
                <div style={{ marginBottom: "12px" }}>
                    <ParameterRow
                        parameter="pageSize"
                        type={"integer"}
                        body={<div>
                            <div style={{ marginBottom: "2px"}}>
                                Number of files per page.
                            </div>
                        </div>}
                    />
                </div>
                <div style={{ marginBottom: "12px" }}>
                    <ParameterRow
                        parameter="total"
                        type={"integer"}
                        body={<div>
                            <div style={{ marginBottom: "2px"}}>
                                Total number of files matching the query.
                            </div>
                        </div>}
                    />
                </div>
                <div style={{ marginBottom: "12px" }}>
                    <ParameterRow
                        parameter="files"
                        type={"array"}
                        body={<div>
                            <div style={{ marginBottom: "2px"}}>
                                Array of file objects. Each file object contains the following properties:
                            </div>
                            <div style={{ marginLeft: "16px", marginTop: "8px" }}>
                                <div style={{ marginBottom: "8px" }}>
                                    <strong>fileID</strong> <span style={{ color: gunaldiStyles.secondaryText }}>(string)</span> - The unique identifier of the file
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                    <strong>name</strong> <span style={{ color: gunaldiStyles.secondaryText }}>(string)</span> - The name of the file
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                    <strong>size</strong> <span style={{ color: gunaldiStyles.secondaryText }}>(integer)</span> - The size of the file in bytes
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                    <strong>createdDt</strong> <span style={{ color: gunaldiStyles.secondaryText }}>(string)</span> - The date the file was created in ISO 8601 format
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                    <strong>updatedDt</strong> <span style={{ color: gunaldiStyles.secondaryText }}>(string)</span> - The date the file was last updated in ISO 8601 format
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                    <strong>apiUrl</strong> <span style={{ color: gunaldiStyles.secondaryText }}>(url)</span> - The API URL to access this file
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                    <strong>sheetNames</strong> <span style={{ color: gunaldiStyles.secondaryText }}>(array)</span> - Array of sheet names within the file
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                    <strong>status</strong> <span style={{ color: gunaldiStyles.secondaryText }}>(string)</span> - The status of the file (e.g., "active", "google_sheet")
                                </div>
                            </div>
                        </div>}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapActionsToProps = {}

export default connect(mapStateToProps, mapActionsToProps)(FilesResponseParams)
